'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';

type UserInfo = { username: string; email: string; tenant_id: number };
type TenantInfo = { id: number; name: string };

function readCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : undefined;
}

export function UserMenu() {
  const router = useRouter();
  const t = useTranslations('nav');
  const [user, setUser] = useState<UserInfo | null>(null);
  const [tenant, setTenant] = useState<TenantInfo | null>(null);

  useEffect(() => {
    try {
      const u = readCookie('gm_user');
      if (u) setUser(JSON.parse(u));
      const tVal = readCookie('gm_tenant');
      if (tVal) setTenant(JSON.parse(tVal));
    } catch {
      /* ignore parse errors */
    }
  }, []);

  const handleLogout = async () => {
    const basePath = process.env.NEXT_PUBLIC_BASE_PATH || '';
    await fetch(`${basePath}/api/auth/logout`, { method: 'POST' });
    router.push('/login');
  };

  // SSO not configured — show DEV badge
  if (!user) {
    return <div className="text-xs text-gray-500">DEV</div>;
  }

  return (
    <div className="flex items-center gap-3 text-xs">
      <span className="text-gray-600">
        {user.username}
        {tenant ? ` · ${tenant.name}` : ''}
      </span>
      <button
        onClick={handleLogout}
        className="text-gray-400 hover:text-error-5 transition-colors"
      >
        {t('logout')}
      </button>
    </div>
  );
}
